import { PATHS } from '@/constants';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Button } from '@tis/shared-tis-ui';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../Dialog.module.scss';

interface NewApplicationSuccessDialogProp {
  onClose: () => void;
}

const NewApplicationSuccessDialog: React.FC<
  NewApplicationSuccessDialogProp
> = ({ onClose }) => {
  const navigate = useNavigate(); // Get the navigate function

  const handleReturnToDashboard = () => {
    navigate(PATHS.APPLICANT.DASHBOARD); // Navigate to the dashboard
    onClose(); // Close the dialog
  };

  return (
    <>
      <DialogContent className={styles.dialogContent}>
        <div className={styles.dialogHeader}>
          <CheckCircleIcon className={styles.checkIcon} />
          <Typography
            component="h5"
            variant="h5"
            sx={{ fontSize: '20px', fontWeight: 'bold' }}
          >
            Application submitted
          </Typography>
        </div>
        <Typography>
          Your Free Translating Service application has been submitted. You will
          be notified when your application has progressed to the next stage.
        </Typography>
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button onClick={handleReturnToDashboard}>Return to Dashboard</Button>
      </DialogActions>
    </>
  );
};

export default NewApplicationSuccessDialog;
